import Vue from 'vue'
import Vuex from 'vuex'
import elementVisibility from "@/store/modules/ElementVisibility";
import reports from '@/store/modules/Reports'
import user from '@/store/modules/User'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    elementVisibility,
    reports,
    user
  },
  state: {
    version: "AT0.1.3"
  },
  mutations: {},
  actions: {},
  getters: {}
})
